import api from "../../shared/api";

/**
 * @typedef {Object} CreatePlaidLinkTokenResponse
 *
 * @property {string} link_token
 * @property {string} expiration
 * @property {string} request_id
 */


/**
 * @typedef {PayrollClient} PayrollClient
 *
 * @type {Function} createPlaidLinkToken
 */
export default class PayrollClient {
    /**
     *
     * @param $http {ng.IHttpService}
    */
    /* @ngInject */
    constructor($http) {
        this.http = $http;
    }

    /**
     * Get a link token that can be used in order to make request to Plaid
     * @returns {IHttpPromise<CreatePlaidLinkTokenResponse>}
     */
    createPlaidLinkToken() {
        return this.http.post(
            `${api.getBase()}/plaid/createLinkToken`,
            {
            }
        )
    }
}
